import { Navigate, Outlet } from 'react-router-dom';
import { type UserRole } from '@app/shared';
import { useCurrentUser, defaultRouteFor } from '@/hooks/useCurrentUser';

// Accepts a single role or a set of allowed roles. A caller whose role is not
// in the allowed set is redirected to their own default route.
export function RequireRole({ role }: { role: UserRole | UserRole[] }) {
  const { role: currentRole, isPending } = useCurrentUser();
  const allowed = Array.isArray(role) ? role : [role];

  if (isPending) {
    return <div className="flex h-screen items-center justify-center">Loading…</div>;
  }
  if (!currentRole || !allowed.includes(currentRole)) {
    return <Navigate to={defaultRouteFor(currentRole)} replace />;
  }
  return <Outlet />;
}
